<!-- Copyright 2025, Common Good Learning Tools LLC -->
<template>
	<k-dialog :value="true" max-width="460px" persistent>
		<k-card>
			<k-card-title>Unpublish All Assets</k-card-title>

			<k-card-text style="color: #000;">
				<p>All published assets in this {{ level }} will be unpublished. What status should they be set to?</p>

				<k-select
					v-model="new_status"
					:items="statuses"
					label="New status"
					outlined dense hide-details
				/>

				<div class="mt-2" style="font-size: 12px;">{{ selected_status.description }}</div>
			</k-card-text>

			<k-card-actions class="pl-4 pr-4 pb-4">
				<k-spacer/>
				<k-btn small class="mr-1" @click="$emit('done')">Cancel</k-btn>
				<k-btn color="red" dark small @click="unpublish_all">Unpublish</k-btn>
			</k-card-actions>
		</k-card>
	</k-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'UnpublishAllDialog',

	props: {
		// 'collection' or 'unit'
		level: {type: String, required: true},
		// lp_id for a collection, lp_unit_id for a unit
		id: {type: [String, Number], required: true},
	},

	data() {
		return {
			new_status: 'unpublished',
		}
	},

	computed: {
		...mapState(['user_info']),

		// must match the statuses unpublish_all_assets.php accepts
		statuses() {
			return [
				{value: 'unpublished', description: 'Take the assets out of the publishing workflow.'},
				{value: 'submitted', description: 'Return the assets to the review queue as newly submitted.'},
				{value: 'under_review', description: 'Return the assets to the review queue as under review.'},
				{value: 'ready_for_publication', description: 'Keep the assets approved, but unpublished, so they can be re-published later.'},
			].map(x => ({...x, text: this.$get_publish_status_data(x.value).text}))
		},

		selected_status() {
			return this.statuses.find(x => x.value == this.new_status)
		},
	},

	methods: {
		unpublish_all() {
			let payload = {
				user_id: this.user_info.user_id,
				level: this.level,
				id: this.id,
				publish_status: this.new_status,
			}

			U.loading_start()
			U.ajax('unpublish_all_assets', payload, result => {
				U.loading_stop()

				if (result.status != 'ok') {
					console.error('unpublish_all_assets error: ', result)
					this.$alert('An error occurred while unpublishing assets.')
					return
				}

				this.$inform({text: result.count + ' assets unpublished. Reloading...'})
				setTimeout(() => { window.location.reload() }, 1000)
			})
		},
	},
}
</script>
